export const SET_LOADING = '@cliente/SET_LOADING';
export const SEARCH_REQUEST = '@cliente/SEARCH_REQUEST';
export const SEARCH_SUCCESS = '@cliente/SEARCH_SUCCCESS';
export const SET_APPLICATION_MODE = '@cliente/SET_APPLICATION_MODE';
